import { SHOW_DOWNLOAD_DETAILS, HIDE_DOWNLOAD_DETAILS } from '../../constants/ActionTypes';

export const initialState = {
  error: null,
  loaded: false,
  loading: false,
  uid: '',
};

export default function downloaddetails(state = initialState, action = {}) {
  switch (action.type) {
    case `${SHOW_DOWNLOAD_DETAILS}`:
      return {
        ...state,
        uid: action.result.uid,
      };

    case `${HIDE_DOWNLOAD_DETAILS}`:
      return {
        ...state,
        uid: '',
      };

    default:
      return state;
  }
}
